import { render, staticRenderFns } from "./ViewStoneType.vue?vue&type=template&id=587d3ca2&"
import script from "./ViewStoneType.vue?vue&type=script&lang=js&"
export * from "./ViewStoneType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports